import React from 'react';
import { Modal } from 'carbon-components-react';

import './update-subscription.styles.scss';
import useSWRMutation from 'swr/mutation';
import { selectCurrentUser } from '../../redux/user/user.selectors';
import { useSelector } from 'react-redux';
import { ConfirmModal } from '../../components/modal/confirm-modal/ConfirmModal.component';
import { postMethod } from '../../api/common';
import { PrintView } from '../../components/PrintView/print-view.component';
import { formatCurrency, formatDate } from '../../utils/common.util';
import CustomButton from '../../components/custom-button/custom-btn.component';

export default function ChequePaymentModal({
  openModal,
  closeModal,
  payment,
  refreshPage,
}) {
  const currentUser = useSelector(selectCurrentUser);
  const [isOpen, setIsOpen] = React.useState('');
  // const [comment, setComment] = React.useState('');

  function onComplete() {
    closeModal();
    setIsOpen('');
    refreshPage();
  }

  // approve
  const { trigger, isMutating, error } = useSWRMutation(
    `school/${payment?.school?.id}/approve-invoice-cheque-payment`,
    (url) =>
      postMethod(url, { invoicePaymentId: payment?.id }, currentUser.authToken),
    {
      onSuccess: () => {
        onComplete();
        closeModal();
      },
      throwOnError: false,
    },
  );

  // decline
  // const {
  //   trigger: declinePayment,
  //   isMutating: isDeclining,
  //   error: declineError,
  // } = useSWRMutation(
  //   `school/${payment?.school?.id}/decline-invoice-cheque-payment`,
  //   (url) => postMethod(url, { comment }, currentUser.authToken),
  // { onSuccess: () => {onComplete(); closeModal()}, throwOnError: false },
  // );

  // reverse
  const {
    trigger: reversePayment,
    isMutating: isReversing,
    error: reverseError,
  } = useSWRMutation(
    `school/${payment?.school?.id}/reverse-invoice-cheque-payment`,
    (url) => postMethod(url, payment, currentUser.authToken),
    {
      onSuccess: () => {
        onComplete();
        closeModal();
      },
      throwOnError: false,
    },
  );

  const modalTitle = `Cheque Payment Details ${
    payment &&
    `[${payment.dateReversed ? 'REVERSED' : `${payment.status.toUpperCase()}`}]`
  }`;

  return (
    <>
      <ConfirmModal
        isOpen={isOpen === 'approve'}
        closeModal={() => setIsOpen('')}
        title="Approve Cheque Payment"
        description={
          <>
            <p className="text-label font-bold">
              NB: Cheque payment cannot be modified after approval, it can only
              be reversed.
            </p>
            <p className="text-label font-normal mt-20">
              Are you sure you want to approve this Cheque Payment?
            </p>
          </>
        }
        actionText="APPROVE"
        onClick={() => trigger()}
        isLoading={isMutating}
        errorMessage={error ? error.message : null}
      />

      {/* <DeclinePurchaseOrderPaymentForm
        isOpen={isOpen === 'decline'}
        closeModal={() => setIsOpen('')}
        comment={comment}
        setComment={setComment}
        onClick={declinePayment}
        isLoading={isDeclining}
        errorMessage={declineError ? declineError.message : null}
      /> */}

      <ConfirmModal
        isOpen={isOpen === 'reverse'}
        closeModal={() => setIsOpen('')}
        title="Reverse Cheque Payment"
        description={
          <>
            <p className="text-label font-normal mt-20">
              Are you sure you want to reverse this Approved Cheque Payment?
            </p>
          </>
        }
        actionText="REVERSE"
        onClick={() => reversePayment()}
        isLoading={isReversing}
        errorMessage={reverseError ? reverseError.message : null}
        actionBtnClasses="danger"
      />

      <Modal
        id="cheque-payment-modal"
        className="cheque-payment-modal"
        hasScrollingContent
        passiveModal={true}
        open={openModal}
        modalHeading={modalTitle}
        primaryButtonDisabled={false}>
        <PrintView>
          {payment && (
            <div>
              <h3 className="print-view">{modalTitle}</h3>

              {/* who reversed the payment */}
              {payment.dateReversed ? (
                <div className="info reversed">
                  {`${
                    payment.reversedBy?.userId === currentUser?.userId
                      ? `You reversed this Payment on ${formatDate(
                          payment.dateReversed,
                        )}`
                      : `${
                          payment.reversedBy?.firstName
                        } reversed this Payment on ${formatDate(
                          payment.dateReversed,
                        )}`
                  }`}
                </div>
              ) : (
                <div>
                  {payment.status === 'Pending' && !payment.dateReversed && (
                    <div className="info pending">
                      {`${
                        payment.submittedBy?.userId === currentUser?.userId
                          ? `You submitted this payment for Approval on ${formatDate(
                              payment.dateCreated,
                            )}`
                          : `${
                              payment.submittedBy?.firstName
                            } submitted this payment for Approval on ${formatDate(
                              payment.dateCreated,
                            )}`
                      }`}

                      {payment.comment && ` with comment "${payment.comment}"`}
                    </div>
                  )}

                  {payment.status === 'Approved' && !payment.dateReversed && (
                    <div className="info approved">
                      {`${
                        payment.approvedBy?.userId === currentUser?.userId
                          ? `You approved this Payment on ${formatDate(
                              payment.dateApproved,
                            )}`
                          : `${
                              payment.approvedBy?.firstName
                            } approved this Payment on ${formatDate(
                              payment.dateApproved,
                            )}`
                      }`}
                    </div>
                  )}

                  {payment.status === 'Declined' && !payment.dateReversed && (
                    <div className="info pending">
                      {`${
                        payment.submittedBy?.userId === currentUser?.userId
                          ? `You declined this Payment for Approval on ${formatDate(
                              payment.dateDeclined,
                            )}`
                          : `${
                              payment.declinedBy?.firstName
                            } declined this Payment on ${formatDate(
                              payment.dateDeclined,
                            )}`
                      }`}

                      {payment.comment && ` with comment "${payment.comment}"`}
                    </div>
                  )}
                </div>
              )}

              <hr className="grey-hr mb-30" />
              <div className="bx--row p-row">
                <div className="bx--col-lg-4 mb-30">
                  <span className="text-grey text-14 ">School</span>
                  <h3 className="text-14 font-600 text-dark">
                    {payment.school.name}
                  </h3>
                </div>
                <div className="bx--col-lg-4 mb-30">
                  <span className="text-grey text-14 ">Cheque Number</span>
                  <h3 className="text-14 font-600 text-dark">
                    {payment.chequeNumber}
                  </h3>
                </div>
                <div className="bx--col-lg-4 mb-30">
                  <span className="text-grey text-14 ">Payment Date</span>
                  <h3 className="text-14 font-600 text-dark">
                    {formatDate(payment.dateCreated)}
                  </h3>
                </div>
                <div className="bx--col-lg-4 mb-30">
                  <span className="text-grey text-14 ">Invoice Number</span>
                  <h3 className="text-14 font-600 text-dark">
                    {payment.invoiceNumber}
                  </h3>
                </div>
              </div>

              <hr className="grey-hr mb-30" />

              <div className="bx--row p-row">
                <div className="bx--col-lg-4 mb-30">
                  <span className="text-grey text-14 ">Amount Paid</span>
                  <h3 className="text-14 font-600 text-dark">
                    {formatCurrency(payment.amountPaid)}
                  </h3>
                </div>

                {/* <div className="bx--col-lg-4 mb-30">
                  <span className="text-grey text-14 ">Mode of payment</span>
                  <h3 className="text-14 font-600 text-dark">
                    {payment.paymentMode}
                  </h3>
                </div>
                <div className="bx--col-lg-4 mb-30">
                  <span className="text-grey text-14 ">Balance Due</span>
                  <h3 className="text-14 font-600 text-dark">
                    {formatCurrency(payment.balanceDue - payment.amount)}
                  </h3>
                </div> */}
                <div className="bx--col-lg-4 mb-30">
                  <span className="text-grey text-14 ">Submitted By</span>
                  <h3 className="text-14 font-600 text-dark">
                    {payment.submittedBy?.firstName}&nbsp;
                    {payment.submittedBy?.lastName}
                  </h3>
                </div>
              </div>
              <hr className="grey-hr mb-30" />
              {/* <div className="p-row">
                <h3 className="text-14 text-grey-dark">Description</h3>
                <p className="text-16 font-500 text-dark">
                  {payment.description}
                </p>
              </div> */}

              <div
                className="mt-40"
                style={{ display: 'flex', justifyContent: 'space-between' }}>
                <CustomButton
                  classes="outline danger no-border no-hover font-bold"
                  onClick={() => closeModal()}>
                  CLOSE
                </CustomButton>

                <div style={{ display: 'flex', gap: '10px' }}>
                  {/* <CustomButton
                    classes="secondary font-bold"
                    onClick={() => {
                      window.print();
                    }}>
                    <Printer size="11" strokeWidth="5px" /> &nbsp; PRINT
                  </CustomButton> */}

                  {payment.status === 'Pending' && !payment.dateReversed && (
                    <>
                      {payment.submittedBy?.userId !== currentUser?.userId && (
                        <>
                          <CustomButton
                            classes="success font-bold ml-20"
                            onClick={() => {
                              setIsOpen('approve');
                              // closeModal();
                            }}>
                            APPROVE
                          </CustomButton>
                          {/* <CustomButton
                            classes="secondary font-bold ml-20"
                            onClick={() => {
                              setIsOpen('decline');
                              // closeModal();
                            }}>
                            DECLINE
                          </CustomButton> */}
                        </>
                      )}
                    </>
                  )}

                  {payment.status === 'Approved' && !payment.dateReversed && (
                    <CustomButton
                      classes="danger font-bold ml-20"
                      onClick={() => {
                        setIsOpen('reverse');
                        // closeModal();
                      }}>
                      REVERSE PAYMENT
                    </CustomButton>
                  )}
                </div>
              </div>
            </div>
          )}
        </PrintView>
      </Modal>
    </>
  );
}
